/* Modals */
// for use with %modal extension in base.scss
// loads into modal.hbs partial
const modal = function(documentElem) {
  let isVideo, cardNode;

  function initModal(params = { isVideo: false }) {
    isVideo = params.isVideo;

    if (isVideo) {
      // set up video player styling
      documentElem.getElementById("page-modal").className += " jsVideo";
      documentElem.getElementById("modal-player").style.display = "flex";

      // add YouTube video player iFrame
      const iframe = `<iframe id="modal-video" width="100%" height="100%" title="YouTube Video Player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
      documentElem.getElementById("modal-player").innerHTML = iframe;
    }

    // listen for click to close modal
    documentElem.getElementById("page-modal")
    .addEventListener("click", function(e) {
      const target = e.target.id || null;
      if (target === "page-modal" || target === "modal-close") {
        closeModal();
      }
    });

    // listen for escape key to close modal
    documentElem.getElementById("page-modal")
    .addEventListener("keydown", function(e) {
      if (e.keyCode == 27) { // esc
        closeModal();
      }
    });

    return {
      launch: launchModal,
      close: closeModal
    }
  }

  function launchModal(e) {
    const target = e.target || e;

    // find main card node (has attr tabindex=0)
    findParent(target);
    function findParent(elem) {
      if (elem.getAttribute("tabindex") == 0) {
        cardNode = elem;
      } else {
        findParent(elem.parentNode);
      }
    }

    // identify img, name, title, description from card
    if (!cardNode) console.log("Parent card not found");
    const ul = cardNode.querySelector("li > ul");
    const cardInfo = Array.from(ul.children);

    // fill modal with information
    if (!isVideo) {
      const img = cardInfo[0].innerHTML || "";
      const name = cardInfo[1].innerHTML || "";
      const title = cardInfo[2].innerHTML || "";
      const desc = cardInfo[3].innerHTML || "";
      documentElem.getElementById("modal-img").innerHTML = img;
      documentElem.getElementById("modal-name").innerHTML = name;
      documentElem.getElementById("modal-title").innerHTML = title;
      documentElem.getElementById("modal-desc").innerHTML = desc;
    } else {
      // retrieves YouTube URL from card and adds it to iframe
      const modalDesc = Array.from(cardInfo[3].children)[0] || false;
      let vidSrc = (modalDesc) ? modalDesc.innerHTML : "";
      vidSrc = vidSrc.replace(
        "https://www.youtube.com/watch?v=",
        "https://www.youtube.com/embed/"
      );
      vidSrc += "?&autoplay=1";
      documentElem.getElementById("modal-video").src = vidSrc;
    }

    // open modal window
    documentElem.getElementById("modal-inner").style.display = "flex";
    documentElem.getElementById("page-modal").style.display = "flex";

    // focus x for easy close
    documentElem.getElementById("modal-close").focus();
  }

  function closeModal() {
    documentElem.getElementById("page-modal").style.display = "none";
    documentElem.getElementById("modal-inner").style.display = "none";
    if (!isVideo) {
      documentElem.getElementById("modal-img").innerHTML = "";
      documentElem.getElementById("modal-name").innerHTML = "";
      documentElem.getElementById("modal-title").innerHTML = "";
      documentElem.getElementById("modal-desc").innerHTML = "";
    } else {
      documentElem.getElementById("modal-video").src = "";
    }

    // focus last closed card for easy keyboard navigation
    cardNode.focus();
  }

  return {
    init: initModal
  }
}
